import { render, staticRenderFns } from "./leftSidebar.vue?vue&type=template&id=5a264755&scoped=true"
import script from "./leftSidebar.vue?vue&type=script&lang=js"
export * from "./leftSidebar.vue?vue&type=script&lang=js"
import style0 from "./leftSidebar.vue?vue&type=style&index=0&id=5a264755&prod&lang=scss"
import style1 from "./leftSidebar.vue?vue&type=style&index=1&id=5a264755&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a264755",
  null
  
)

export default component.exports